import { Trophy, Crown } from "lucide-react";

const STATE_STYLE = {
  live: "bg-green-600 text-white",
  upcoming: "bg-[var(--trio-accent)] text-[var(--trio-text)]",
  ended: "bg-[var(--trio-text)] text-[var(--trio-bg)]",
};

export const ContestStateBadge = ({ state }) => (
  <span data-testid="contest-state" className={`text-[10px] tracking-[0.25em] uppercase font-bold px-2 py-1 ${STATE_STYLE[state]}`}>
    {state === "live" ? "Live Now" : state}
  </span>
);

export const PointsRules = () => (
  <p className="text-xs text-[var(--trio-muted)]">
    <strong>1 pt</strong> per RSVP from your link that shows up &amp; gets scanned · <strong>1 pt</strong> per ticket scanned at the door ·{" "}
    <strong>1 pt</strong> per 5-star review.
  </p>
);

export const ContestBoard = ({ contest, standings, testid = "contest-board" }) => {
  const leader = standings[0]?.points > 0 ? standings[0] : null;
  return (
    <div data-testid={testid} className="border border-[var(--trio-border)] bg-[var(--trio-surface)]">
      <div className="p-5 border-b border-[var(--trio-border)] flex flex-wrap gap-3 items-start justify-between">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <Trophy className="w-4 h-4 text-[var(--trio-primary)]" />
            <ContestStateBadge state={contest.state} />
          </div>
          <h3 data-testid={`${testid}-name`} className="font-display uppercase text-2xl tracking-tight">{contest.name}</h3>
          <div className="text-xs text-[var(--trio-muted)]">{contest.starts_on} → {contest.ends_on}</div>
        </div>
        {contest.prize && (
          <div data-testid={`${testid}-prize`} className="text-right">
            <div className="text-[10px] tracking-[0.3em] uppercase text-[var(--trio-muted)]">Prize</div>
            <div className="font-display uppercase text-xl text-[var(--trio-primary)]">{contest.prize}</div>
          </div>
        )}
      </div>
      {leader && (
        <div data-testid={`${testid}-leader`} className="px-5 py-3 bg-[var(--trio-accent)]/30 flex items-center gap-2 text-sm">
          <Crown className="w-4 h-4" /> {contest.state === "ended" ? "Winner" : "Leading"}: <strong>{leader.name}</strong> · {leader.points} pts
        </div>
      )}
      <table className="w-full text-sm">
        <thead>
          <tr className="text-[10px] tracking-[0.25em] uppercase text-[var(--trio-muted)] text-left">
            <th className="px-5 py-2">#</th><th className="px-2 py-2">Name</th>
            <th className="px-2 py-2 text-right">RSVPs</th><th className="px-2 py-2 text-right">Tickets</th><th className="px-2 py-2 text-right">5★</th>
            <th className="px-5 py-2 text-right">Points</th>
          </tr>
        </thead>
        <tbody>
          {standings.map((r) => (
            <tr key={r.id} data-testid={`${testid}-row-${r.rank}`} className={`border-t border-[var(--trio-border)] ${r.is_me ? "bg-[var(--trio-primary)]/10 font-semibold" : ""}`}>
              <td className="px-5 py-2 font-display text-lg">{r.rank}</td>
              <td className="px-2 py-2">{r.name}{r.is_me ? " (you)" : ""}</td>
              <td className="px-2 py-2 text-right">{r.rsvps}</td>
              <td className="px-2 py-2 text-right">{r.tickets}</td>
              <td className="px-2 py-2 text-right">{r.five_stars ?? 0}</td>
              <td className="px-5 py-2 text-right font-display text-xl text-[var(--trio-primary)]">{r.points}</td>
            </tr>
          ))}
          {standings.length === 0 && (
            <tr><td colSpan={6} className="px-5 py-6 text-center text-[var(--trio-muted)]">No team members yet.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
